/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehaviorBipInfoModel } from '../../models/behavior-bip-info-model';

export interface GetNewBehaviorBIPInfoByBehavior$Params {
  patientID?: number;
  patientBehaviorID?: number;
}

export function GetNewBehaviorBIPInfoByBehavior(http: HttpClient, rootUrl: string, params?: GetNewBehaviorBIPInfoByBehavior$Params, context?: HttpContext): Observable<StrictHttpResponse<BehaviorBipInfoModel>> {
  const rb = new RequestBuilder(rootUrl, GetNewBehaviorBIPInfoByBehavior.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('patientBehaviorID', params.patientBehaviorID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BehaviorBipInfoModel>;
    })
  );
}

GetNewBehaviorBIPInfoByBehavior.PATH = '/api/Staff/GetNewBehaviorBIPInfoByBehavior';
